import React from "react";
import PriceSlider from "./PriceSlider";
import AreaSlider from "./AreaSlider";
import NumberSlider from "./NumberSlider";
import PercentageSlider from "./PercentageSlider";

const RangeSlider: React.FC<{ range: any }> = ({ range }) => {
  switch (range.instanceNamespace) {
    case "dk.realequity.ie.range.price":
      return <PriceSlider name="priceRange" title="Pris" range={range} />;

    case "dk.realequity.ie.range.boligstoerrelse":
      return (
        <AreaSlider name="livingAreaRange" title="Boligareal" range={range} />
      );

    case "dk.realequity.ie.range.rooms":
      return (
        <NumberSlider name="roomRange" title="Antal værelser" range={range} />
      );

    case "dk.realequity.ie.range.grundstoerrelse.ha":
      return <NumberSlider name="plotRange" title="plotRange" range={range} />;

    case "dk.realequity.ie.range.etageareal":
      return (
        <AreaSlider name="floorAreaRange" range={range} title="Etageareal" />
      );

    case "dk.realequity.ie.range.forrentningsprocent":
      return (
        <PercentageSlider
          name="rateOfReturnRange"
          title="Forrentningsprocent"
          range={range}
        />
      );

    case "dk.realequity.ie.range.lejepraar":
      return (
        <NumberSlider name="rentYearlyRange" title="Årlig leje" range={range} />
      );

    default:
      // console.warn(
      //   `RangeSlider: Unsupported range type: ${range.instanceNamespace}`
      // );
      return null;
  }
};

export default RangeSlider;
